import React, { Fragment, useState, useEffect, useContext } from "react";
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H4, P, Image } from "../AbstractElements";
import { EmailAddress, Password, SignIn } from "../Constant";

import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { requestForToken } from "../firebase";
import axiosInstance, { axiosNAKBHOInstance } from "../interceptor/intercetptor-inctence";
// import Loader from "../Layout/Loader";
import logoLight from '../../src/assets/images/login/logo_white.png';
import logoDark from '../../src/assets/images/login/logo_dark.png';
import assets5 from '../../src/assets/images/login/Asset-5.png';
import coatOfArms from '../../src/assets/images/login/Coat_of_arms_of_Zimbabwe.png';
import { useTranslation } from "react-i18next";
import { useClinicAdmin } from "../_helper/ClinicProvider";
import PrivilegeContext from "../_helper/PrivilegeContext";
import { useLoader } from "../_helper/LoaderContext";
import { secureApiRequest } from "../Services/secureApiRequest";
import { decryptResponseData } from "../Services/decryptApiResponse";
import { useLab } from "../_helper/PharmacyProvider";
import { useLicense } from "../_helper/LicenseContext";
import { withLoginTax } from "../utils/taxConfig";


const Signin = ({ selected }) => {
	const { t } = useTranslation();
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [emailError, setEmailError] = useState("");
	const [passwordError, setPasswordError] = useState("");
	const [togglePassword, setTogglePassword] = useState(false);
	const history = useNavigate();
	const [token, setToken] = useState('');
	const { setLoading } = useLoader();
	const { clinicAdmin, setClinicAdmin } = useClinicAdmin();
	const { setCurrentLab } = useLab();
	const { setUserPrivileges } = useContext(PrivilegeContext);
	const user = localStorage.getItem('currentLab')
	const { decodeTokenOnly, decodeJWT, saveLicenseToken, getStoredLicenseToken, checkLicense, doesLicenseBelongToUser } = useLicense();

	useEffect(() => {
		if (user) history(`${process.env.PUBLIC_URL}/dashboard`);
	}, [])

	const [allowedUsers, setAllowedUsers] = useState([]);

	useEffect(() => {
		decodeTokenOnly()
			.then((decoded) => {
				if (decoded?.users) {
					setAllowedUsers(decoded.users);
				} else {
					setAllowedUsers([]);
				}
			})
			.catch(() => setAllowedUsers([]));
	}, []);

	const [containerHeight, setContainerHeight] = useState(window.innerHeight);
	useEffect(() => {
		const handleResize = () => {
			setContainerHeight(window.innerHeight);
		};

		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	const getFCMToken = () => {
		Notification.requestPermission().then((permission) => {
			if (permission === "granted") {
				console.log("Notification permission granted.");
				requestForToken()
					.then((currentToken) => {
						if (currentToken) {
							setToken(currentToken);
						} else {
							console.log(
								"No registration token available. Request permission to generate one."
							);
						}
					})
					.catch((err) => {
						console.log("An error occurred while retrieving token. ", err);
					});
			} else {
				console.log("Unable to get permission to notify.");
				toast.warning(t("Please allow notifications to receive updates."));
			}
		});
	};

	const handleEmailChange = (e) => {
		setEmail(e.target.value);
		setEmailError(""); // Clear email error when user types
	};

	const handlePasswordChange = (e) => {
		setPassword(e.target.value);
		setPasswordError(""); // Clear password error when user types
	};

	const validateFields = () => {
		let isValid = true;

		// Email validation
		if (!email) {
			setEmailError("Email is required");
			isValid = false;
		} else if (!/\S+@\S+\.\S+/.test(email)) {
			console.log("Invalid email format");
			setEmailError("Please enter a valid email address");
			isValid = false;
		}

		// Password validation
		if (!password) {
			setPasswordError("Password is required");
			isValid = false;
		}

		return isValid;
	};

	const pharmacyLogin = async (e) => {
		e.preventDefault();
		if (validateFields()) {
			const form_data = new FormData();
			form_data.append("email", email);
			form_data.append("password", password);
			try {
				setLoading(true);
				const response = await axiosInstance.post('api/lab-user/login', form_data)
				if (response.data.success === true) {
					const loggedInUser = withLoginTax(response.data.data.safeUser, response.data.data);

					const serverLicenseToken = loggedInUser.licenseToken;
					localStorage.setItem('currentLab', JSON.stringify(loggedInUser));
					localStorage.setItem('currentLabAuth', response.data.data.accessToken);
					const headerFooter = {
						headerTest: response.data.data.safeUser.settings.headerText,
						footerText: response.data.data.safeUser.settings.footerText,
						headerLogo: response.data.data.safeUser.settings.headerLogo
					}
					localStorage.setItem("header", JSON.stringify(headerFooter));
					localStorage.setItem("licenseKey", loggedInUser.licenseKey)
					setCurrentLab(loggedInUser);
					if (loggedInUser.licenseToken !== null) {
						if (serverLicenseToken) {
							await saveLicenseToken(serverLicenseToken);
							const decoded = await decodeJWT(serverLicenseToken);
							const isAllowedUser = decoded?.users?.some(
								(user) => user.id === loggedInUser._id
							);

							if (isAllowedUser) {
								history(`${process.env.PUBLIC_URL}/dashboard`, { replace: true });
								return;
							} else {
								toast.warning(t("User is not registered with us. Please contact the ClinicDots admin."));
								history(`${process.env.PUBLIC_URL}/login`, { replace: true });
								localStorage.clear();
							}
						}
					}
					else {
						history(`${process.env.PUBLIC_URL}/activate`);
					}
				}
			} catch (error) {
				console.error('Error fetching data:', error);
			} finally {
				setLoading(false);
			}
		}
	}

	const loginAuth = async (e) => {
		e.preventDefault();
		if (validateFields()) {
			const body = {
				email: email.toLowerCase(),
				password: password,
				device_info: {
					platform: 'web',
					token: token,
					device_id: '',
				}
			}
			try {
				setLoading(true);
				// const response = await axiosInstance.post('clinic_admin/auth/login', body)
				const response = await secureApiRequest("post", 'clinic_admin/auth/login', body)
				const dec_data = decryptResponseData(response);
				// dec_data = response.data;
				// if (response.data.data.clinic_admin.role === 'clinic_admin') {
				if (dec_data.data.clinic_admin) {
					localStorage.setItem('hospitalAdminAuth', dec_data.data.token)
					localStorage.setItem('currentHospitalAdmin', JSON.stringify(dec_data.data.clinic_admin))
					setClinicAdmin(dec_data.data.clinic_admin);
					// setUserPrivileges(dec_data.data.clinic_admin.privileges_profiles : null)
					if (dec_data.data.clinic_admin.role === 'clinic_admin') {
						setUserPrivileges(null)
					} else {
						setUserPrivileges(dec_data.data.clinic_admin.privileges_profiles || null);
					}
					if (dec_data.data.clinic_admin.role === "clinic_admin" && dec_data.data.clinic_admin.currency === false) {
						history(`${process.env.PUBLIC_URL}/clinic_admin_settings`);
					} else {
						history(`${process.env.PUBLIC_URL}/dashboard`);
					}
				}
			} catch (error) {
				console.error('Error fetching data:', error);
			}
			finally {
				setLoading(false);
			}
		}
	};

	const forgotPassword = () => {
		history(`${process.env.PUBLIC_URL}/forgot-password`);
	};

	return (
		<Fragment>
			<div className="login-page">
				<Container fluid={false} style={{ paddingTop: '1rem', paddingBottom: '0.5rem' }}>
					<div className="card">
						<Row className="m-0">
							<Col
								xs="6"
								className="b-center bg-size d-none d-md-flex flex-column"
								style={{
									backgroundImage: `url(${require('../assets/images/login/login_left_img.png')})`,
									backgroundSize: 'cover',
									backgroundPosition: 'center',
									borderTopLeftRadius: '15px',
									borderBottomLeftRadius: '15px',
									// padding: '20px',
									color: '#1b255b', // Ensures text is white on the dark background
								}}
							>
								<div className="d-flex tw-flex-col tw-gap-2" style={{ marginLeft: "10%" }}>
									<Image
										attrImage={{
											className: 'login-logo-style',
											src: `${logoLight}`,
											alt: 'NAKBHO Logo',
										}}
									/>
									{/* <h3 style={{ fontWeight: 'bold', marginBottom: '0px' }}>CLINICDOTS</h3>
									<h3 style={{ fontWeight: 'bold', marginBottom: '20px' }}>NOORILAB</h3> */}
									<span>{t("Innovating Healthcare for India")}</span>
								</div>
							</Col>

							<Col xs="12" md="6"
								style={{
									backgroundImage: `url(${require('../assets/images/login/login_right_img.png')})`,
									backgroundSize: 'contain',
									backgroundPosition: 'center',
									borderTopRightRadius: '15px',
									borderBottomRightRadius: '15px',
									minHeight: `${containerHeight * 0.94}px`,
									display: 'flex',
									flexDirection: 'column'
								}}>
								<div className='login-card' style={{ flex: '1' }}>
									<div className="login-form-responsive">
										<Form className="theme-form login-form">
											{/* This image will only be visible on mobile screens */}
											<Image
												attrImage={{
													className: 'login-dark-logo-style d-block d-md-none',
													src: `${logoDark}`,
													alt: 'NAKBHO Logo',
												}}
											/>
											<H4><strong className="mb-3">{t("Login")} - {t("Lab")}</strong></H4>
											<P>{t("Welcome to")} <strong>CLINICDOTS</strong> {t("Lab")}</P>

											<FormGroup className="position-relative">
												<Label className="col-form-label">{t("Email")}</Label>
												<div className="position-relative">
													<i className="fa fa-envelope-o position-absolute" style={{ left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#000', fontSize: "large" }}></i>
													<Input
														className="pl-5 form-control"
														type="email"
														placeholder={t("Enter email")}
														onChange={handleEmailChange}
														value={email}
														style={{ paddingLeft: '40px' }}
													/>
												</div>
												{emailError && <div className="text-danger">{t(emailError)}</div>}
											</FormGroup>

											<FormGroup className="position-relative">
												<Label className="col-form-label">{t("Password")}</Label>
												<div className="position-relative">
													<i className="fa fa-lock position-absolute"
														style={{
															left: '10px',
															top: '50%',
															transform: 'translateY(-50%)',
															color: '#000',
															fontSize: "x-large"
														}}></i>
													<Input
														className="pl-4 form-control"
														type={togglePassword ? "text" : "password"}
														placeholder={t("Enter password")}
														onChange={handlePasswordChange}
														value={password}
														style={{ paddingLeft: '40px' }}
													/>
													<div
														className="position-absolute"
														style={{
															right: '10px',
															top: '50%',
															transform: 'translateY(-50%)',
															cursor: 'pointer',
															color: '#000',
															fontSize: "x-large"
														}}
														onClick={() => setTogglePassword(!togglePassword)}
													>
														<i className={`fa ${togglePassword ? 'fa-eye-slash' : 'fa-eye'}`} aria-hidden="true"></i>
													</div>
												</div>
												{passwordError && <div className="text-danger">{t(passwordError)}</div>}
											</FormGroup>

											<p style={{ textAlign: "end" }}><strong style={{ cursor: "pointer" }} onClick={forgotPassword}>{t("Forgot Password ?")}</strong></p>
											<div className="mb-0 position-relative form-group">
												<Btn attrBtn={{ type: "submit", color: "primary", className: "d-block w-100 login-button", onClick: (e) => pharmacyLogin(e) }}>{t("Login")}</Btn>
											</div>
										</Form>
									</div>
								</div>
								<div className="mx-3 display: flex; align-items: center; justify-content: center;" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
									<small className="my-3">
										{t("All rights reserved Copyright ©")} {new Date().getFullYear()} {t("CLINICDOTS HEALTHCARE.")}
									</small>
								</div>
							</Col>
						</Row>
					</div>
				</Container>
			</div>
		</Fragment>
	);
};

export default Signin;
